import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const ContentContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  color: #8a2be2;
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2rem;
`;

const Section = styled.div`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: #4a5d4e;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  border-bottom: 2px solid #cc99ff;
  padding-bottom: 0.5rem;
`;

const ItemList = styled.ul`
  list-style: none;
  padding: 0;
`;

const Item = styled.li`
  margin-bottom: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #cc99ff;
`;

const Link = styled.a`
  color: #0066cc;
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;

const VeloContent = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  // Función para limpiar caracteres especiales
  const cleanSpecialChars = (text) => {
    return text
      .replace(/&aacute;/g, 'á')
      .replace(/&eacute;/g, 'é')
      .replace(/&iacute;/g, 'í')
      .replace(/&oacute;/g, 'ó')
      .replace(/&uacute;/g, 'ú')
      .replace(/&ntilde;/g, 'ñ')
      .replace(/&ccedil;/g, 'ç')
      .replace(/&ordf;/g, 'ª')
      .replace(/&ordm;/g, 'º')
      .replace(/&iquest;/g, '¿')
      .replace(/&iexcl;/g, '¡')
      .replace(/&uuml;/g, 'ü')
      .replace(/&ouml;/g, 'ö')
      .replace(/&auml;/g, 'ä')
      .replace(/&egrave;/g, 'è')
      .replace(/&agrave;/g, 'à')
      .replace(/&ocirc;/g, 'ô')
      .replace(/&acirc;/g, 'â')
      .replace(/&ecirc;/g, 'ê')
      .replace(/&icirc;/g, 'î')
      .replace(/&ucirc;/g, 'û')
      .replace(/&atilde;/g, 'ã')
      .replace(/&otilde;/g, 'õ')
      .replace(/&etilde;/g, 'ẽ')
      .replace(/&itilde;/g, 'ĩ')
      .replace(/&utilde;/g, 'ũ')
      .replace(/&atilde;/g, 'ã')
      .replace(/&otilde;/g, 'õ')
      .replace(/&ntilde;/g, 'ñ')
      .replace(/&ccedil;/g, 'ç');
  };

  useEffect(() => {
    const loadContent = async () => {
      try {
        const response = await fetch('actividades/areasdetrabajo/jornadas/velo.htm');
        const html = await response.text();
        
        // Decodificar caracteres especiales
        let decodedHtml = html;
        try {
          // Intentar decodificar caracteres especiales
          decodedHtml = decodeURIComponent(escape(html));
        } catch (e) {
          // Si falla, usar el HTML original
          console.log('Usando HTML original para codificación');
        }
        
        // Crear un elemento temporal para parsear el HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = decodedHtml;
        
        // Extraer el contenido principal
        const mainContent = tempDiv.querySelector('td[bgcolor="#FFFFFF"]');
        
        if (mainContent) {
          const cleanedContent = cleanSpecialChars(mainContent.innerHTML);
          setContent(cleanedContent);
        } else {
          setContent('No se pudo cargar el contenido');
        }
      } catch (error) {
        console.error('Error cargando contenido:', error);
        setContent('Error al cargar el contenido');
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, []);

  if (loading) {
    return (
      <ContentContainer>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <p>Cargando contenido...</p>
        </div>
      </ContentContainer>
    );
  }

  return (
    <ContentContainer>
      <meta charSet="iso-8859-1" />
      <Title>Uso de signos religiosos</Title>
      
      <Section>
        <SectionTitle>Transcripciones de las Jornadas</SectionTitle>
        <ItemList>
          <Item>
            <Link href="/velo-presentacion">
              Transcripción del discurso de presentación
            </Link>
            <p>Por Doña Gemma Coira (Tertulia Feminista Les Comadres)</p>
          </Item>
          
          <Item>
            <Link href="/velo-inauguracion">
              Transcripción del discurso de inauguración
            </Link>
            <p>Por Doña Mª José Ramos (Consejera de la Presidencia del Gobierno del Principado de Asturias)</p>
          </Item>
          
          <Item>
            <Link href="/velo-valcarcel">
              Fundamentalismo religioso y las mujeres: las razones del manifiesto "Ni putas ni sumisas"
            </Link>
            <p>Conferencia impartida por Doña Amelia Valcárcel</p>
          </Item>
          
          <Item>
            <Link href="/velo-bessis">
              La polémica sobre el velo en Francia: contenido y consecuencias
            </Link>
            <p>Conferencia impartida por Doña Sophie Bessis</p>
          </Item>
          
          <Item>
            <Link href="/velo-clausura">
              Transcripción del discurso de clausura
            </Link>
            <p>Por Doña Dulce Gallego Canteli (Concejala de Políticas de Igualdad del Ayuntamiento de Gijón)</p>
          </Item>
        </ItemList>
      </Section>
      
      <Section>
        <SectionTitle>Artículos de Prensa</SectionTitle>
        <ItemList>
          <Item>
            <Link href="../../publicaciones/enlaweb/velo_1.pdf" target="_blank">
              El hijab
            </Link>
            <p>Entrevista con Sophie Bessis realizada por el Grupo Eleuterio Quintanilla</p>
          </Item>
          
          <Item>
            <Link href="../../publicaciones/enlaweb/velo_4.pdf" target="_blank">
              El velo esconde algo más grave
            </Link>
            <p>26/10/2004 - El Comercio</p>
          </Item>
          
          <Item>
            <Link href="../../publicaciones/enlaweb/velo_5.pdf" target="_blank">
              "El velo islámico es una resistencia a la integración"
            </Link>
            <p>26/10/2004 - La Nueva España: Amelia Valcárcel</p>
          </Item>
          
          <Item>
            <Link href="../../publicaciones/enlaweb/velo_7.pdf" target="_blank">
              Si la integración es inteligente, los inmigrantes se alinearán con la autoridad
            </Link>
            <p>27/10/2004 - Entrevista con Sophie Bessis en La Nueva España</p>
          </Item>
        </ItemList>
      </Section>
      
      <div style={{ 
        textAlign: 'center', 
        marginTop: '3rem', 
        padding: '1rem',
        backgroundColor: '#f8f9fa',
        borderRadius: '6px',
        border: '1px solid #cc99ff'
      }}>
        <p style={{ margin: 0, color: '#666' }}>
          <strong>Jornadas:</strong> "Ley contra el uso de signos religiosos en la escuela pública francesa, ¿era necesaria?"
        </p>
        <p style={{ margin: '0.5rem 0 0 0', color: '#666', fontSize: '0.9rem' }}>
          25 y 26 de Octubre de 2004
        </p>
      </div>
    </ContentContainer>
  );
};

export default VeloContent; 